import React, { useEffect, useState } from "react";
import Header from "../components/header/Header";
import FloatingButton from "../components/bottomtotop/FloatingButton";
import Footer from "../components/footer/Footer";
import {
  TbApi,
  TbArrowsShuffle,
  TbChartHistogram,
  TbPin,
  TbRoute,
  TbRouteSquare,
  TbSettingsUp,
} from "react-icons/tb";
import {
  FaCartShopping,
  FaClockRotateLeft,
  FaLink,
  FaQuoteLeft,
  FaQuoteRight,
  FaRegCalendarDays,
  FaRegClock,
  FaRegFileLines,
  FaRegStar,
  FaSliders,
} from "react-icons/fa6";
import { BsBoxSeam, BsFillShieldLockFill } from "react-icons/bs";
import { AiOutlineBars } from "react-icons/ai";
import { IoMdSearch } from "react-icons/io";
import { MdOutlineLocationCity, MdWindow } from "react-icons/md";
import { LuBellRing, LuFilter, LuTruck } from "react-icons/lu";
import { RxCounterClockwiseClock } from "react-icons/rx";
import { PiNotePencilBold } from "react-icons/pi";
import { IoLocationOutline } from "react-icons/io5";
import { FiArrowRight, FiDownloadCloud } from "react-icons/fi";
import slidestep1 from "../../assets/images/slidestep1.svg";
import slidestep2 from "../../assets/images/slidestep2.svg";
import slidestep3 from "../../assets/images/slidestep3.svg";
import pattern1light from "../../assets/images/pattern1-light.svg";
import solution_2 from '../../assets/images/solution_2.png'

const OrderManagementSoftware = () => {
  const featurestab = [
    {
      id: 0,
      label: "Efficiency",
      title: "Increased Efficiency",
      description:
        "Streamline processes and automate tasks, saving time and resources.",
      icon: <TbSettingsUp className="text-xl text-primary-500" />,
      progress: "33%",
      image: slidestep1,
    },
    {
      id: 1,
      label: "Decision Making",
      title: "Enhanced Decision Making",
      description:
        "Leverage data-driven insights and analytical tools to make informed decisions with confidence and precision.",
      icon: <TbRoute className="text-xl text-primary-500" />,
      progress: "67%",
      image: slidestep2,
    },
    {
      id: 2,
      label: "Scalability",
      title: "Achieving Scalability",
      description:
        "Build flexible systems and frameworks that grow seamlessly with your business.",
      icon: <TbRoute className="text-xl text-primary-500" />,
      progress: "100%",
      image: slidestep3,
    },
  ];
  const [active, setActive] = useState(0);
  const current = featurestab[active];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % featurestab.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [featurestab.length]);

  const features1 = [
    {
      title: "Instant Setup",
      description:
        "Start taking B2B orders within minutes with Selzor’s easy setup wizard.",
      icon: <FaRegClock />,
    },
    {
      title: "Secure & Private",
      description: "Your data is fully protected on AWS-hosted secure servers.",
      icon: <BsFillShieldLockFill />,
    },
    {
      title: "API Integration",
      description:
        "Connect seamlessly with your Accounting or ERP system via REST API.",
      icon: <TbApi />,
    },
    {
      title: "Private Product Catalogue",
      description:
        "Organize products with categories, photos, and instant search.",
      icon: <AiOutlineBars />,
    },
    {
      title: "Pricing Tiers",
      description: "Offer different prices for different buyer groups.",
      icon: <FaSliders />,
    },
    {
      title: "Volume Pricing",
      description: "Offer different prices for different buyer groups.",
      icon: <FaRegCalendarDays />,
    },
  ];

  const features2 = [
    {
      title: "Keypress Product Search",
      description: "Find products instantly with real-time search as you type.",
      icon: <IoMdSearch />,
    },
    {
      title: "List / Thumbnail View",
      description:
        "View products and categories in list or thumbnail mode-your choice.",
      icon: <MdWindow />,
    },
    {
      title: "Territory Management",
      description:
        "Easily link buyers and sales reps by territory for smooth operations.",
      icon: <MdOutlineLocationCity />,
    },
    {
      title: "Filter Products",
      description:
        "Quickly filter by category, badge, or offers to narrow your search.",
      icon: <LuFilter />,
    },
    {
      title: "Stock Information",
      description:
        "Keep sales reps updated with live stock availability—no calls needed.",
      icon: <BsBoxSeam />,
    },
    {
      title: "Order Cart Sync",
      description:
        "See live cart updates across all connected users in real time.",
      icon: <RxCounterClockwiseClock />,
    },
  ];

  const features3 = [
    {
      title: "Multiple Order Carts",
      description:
        "Place urgent orders separately without clearing your main cart.",
      icon: <FaCartShopping />,
    },
    {
      title: "Pin Order Item",
      description:
        "Pin important items to ensure they’re included in every processed order.",
      icon: <TbPin />,
    },
    {
      title: "Order Item Notes",
      description:
        "Let sales reps add specific details or buyer requirements to each item.",
      icon: <PiNotePencilBold />,
    },
    {
      title: "Pending Orders/Items",
      description:
        "Easily track pending orders and items with the Adjustment Cart.",
      icon: <TbArrowsShuffle />,
    },
    {
      title: "Geolocation",
      description:
        "See exactly where an order was placed with location tracking.",
      icon: <IoLocationOutline />,
    },
    {
      title: "Push Notifications",
      description: "Get instant alerts when a BUYER PLACES a new order.",
      icon: <LuBellRing />,
    },
  ];

  const features4 = [
    {
      title: "Order History",
      description:
        "Check a buyer’s past orders and see items still in their cart.",
      icon: <FaRegCalendarDays />,
    },
    {
      title: "Order Activity",
      description: "Track every status change with step-by-step order updates.",
      icon: <FaClockRotateLeft />,
    },
    {
      title: "Export Orders",
      description:
        "Download orders in XLS or PDF, with JSON and XML export options.",
      icon: <FiDownloadCloud />,
    },
    {
      title: "Buyer Rating Tiers",
      description:
        "Rate buyers with stars and unlock features based on their rating.",
      icon: <FaRegStar />,
    },
    {
      title: "Multiple Shipping Addresses",
      description:
        "Store multiple addresses for accurate and flexible deliveries.",
      icon: <LuTruck />,
    },
    {
      title: "Auto Link Sales Reps",
      description: "Automatically connect buyers and sales reps by territory.",
      icon: <FaLink />,
    },
  ];

  const renderFeatures = (features) => (
    <div className="grid grid-cols-12 gap-3">
      {features.map((feature, index) => (
        <div key={index} className="col-span-12 sm:col-span-6 lg:col-span-4">
          <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full">
            <div className="relative p-6 sm:p-8 md:p-10 flex flex-col items-start h-full gap-8">
              <div className="bg-[rgba(7,_166,_152,_0.6)] filter blur-[75px] w-[151px] h-[151px] absolute -top-[80px] -right-[100px]"></div>
              <span className="text-4xl text-[#1a9588] bg-white rounded-full p-5">
                {feature.icon}
              </span>
              <div className="flex flex-col text-start gap-2">
                <h4 className="text-2xl">{feature.title}</h4>
                <p className="text-lg text-gray-700">{feature.description}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
  return (
    <div>
      <Header />
      <section>
        <div className="mx-auto max-w-7xl pt-8 md:pt-8 lg:pt-8 py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 lg:gap-6">
            <div className="animate-y flex flex-col text-center items-center gap-2 sm:gap-3 lg:gap-6">
              <h1 className="max-w-[280px] xs:max-w-[350px] sm:max-w-[500px] lg:max-w-[890px] text-2xl xs:text-3xl sm:text-4xl lg:text-6xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
                Efficient Order Handling for Enterprises
              </h1>
              <p className="max-w-[280px] xs:max-w-[343px] lg:max-w-6xl text-gray-600 text-base xs:text-lg sm:text-xl">
                Automate your entire ordering process with Selzor’s Web and
                Mobile Apps. Record every order—whether it comes through phone,
                email, or WhatsApp—and access real-time reports to fulfill them
                faster. With our API, seamlessly integrate Selzor with your
                preferred Inventory, Invoicing, Accounting, or ERP system.
              </p>
              <div>
                {/* <img className="w-44" src={platforms} alt="" /> */}
              </div>
              <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                <a
                  href="/features"
                  className="bg-[#1a9588] hover:shadow-xl text-white px-4 sm:px-4 lg:px-8 py-2 sm:py-3 lg:py-2 rounded-full text-sm sm:text-base font-medium hover:bg-[#28b5a6] transition"
                >
                  Features
                </a>
                <a
                  href="/why-selzor"
                  className="bg-[#1a9588] hover:shadow-xl text-white px-4 sm:px-4 lg:px-8 py-2 sm:py-3 lg:py-2 rounded-full text-sm sm:text-base font-medium hover:bg-[#28b5a6] transition"
                >
                  Why Selzor
                </a>
                <a
                  href="/pricing"
                  className="bg-[#1a9588] hover:shadow-xl text-white px-4 sm:px-4 lg:px-8 py-2 sm:py-3 lg:py-2 rounded-full text-sm sm:text-base font-medium hover:bg-[#28b5a6] transition"
                >
                  Pricing
                </a>
                <a
                  href="https://b2b.selzor.com/"
                  className="
                              group relative inline-flex items-center justify-center
                              rounded-full border border-[#1a9588]
                              px-5 sm:px-6 lg:px-8 py-2.5
                              text-sm sm:text-base font-medium text-[#1a9588]
                              transition
                              hover:shadow-[0_8px_24px_rgba(26,149,136,0.25)]
                              focus:outline-none focus-visible:ring-4 focus-visible:ring-[#28b5a6]/30
                              active:scale-[0.98]
                              overflow-hidden
                            "
                >
                  {/* subtle gradient hover fill */}
                  <span
                    className="
                                absolute inset-0 -z-10
                                bg-gradient-to-r from-[#1a9588]/0 via-[#1a9588]/0 to-[#1a9588]/0
                                transition-all duration-300
                                group-hover:from-[#1a9588]/8 group-hover:via-[#1a9588]/10 group-hover:to-[#1a9588]/12
                              "
                  />
                  {/* soft glow ring on hover */}
                  <span
                    className="
                                absolute inset-0 -z-20 rounded-full
                                ring-0 group-hover:ring-8 ring-[#28b5a6]/10
                                transition-all duration-300
                              "
                  />
                  START SELLING FREE
                  <FiArrowRight
                    className="ml-2 translate-x-0 group-hover:translate-x-0.5 transition-transform"
                    aria-hidden="true"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mt-8 sm:mt-10 lg:mt-12 xl:mt-[52px]">
            <div className="basis-full sm:basis-7/12 lg:basis-8/12">
              <div
                className="animate-y-down bg-no-repeat bg-center bg-cover h-full rounded-2xl sm:rounded-3xl md:rounded-[32px] lg:rounded-[40px] bg-[#dbf4f1] overflow-hidden relative"
                style={{ backgroundImage: `url(${pattern1light})` }}
              >
                <div className="overflow-hidden relative h-full min-h-[180px] xs:min-h-[210px] sm:min-h-[300px] md:min-h-[350px] lg:min-h-[400px] w-full flex items-center justify-center">
                  <div className="text-center max-w-xl p-3 mx-auto  text-gray-800 space-y-4">
                    <div className="flex justify-center text-2xl text-[#1a9588]">
                      <FaQuoteLeft />
                    </div>
                    <p className="text-lg sm:text-xl font-medium">
                      Advanced Real-Time Reports
                    </p>
                    <p className="text-sm sm:text-base">
                      With accurate insights, we can forecast production and
                      purchasing needs with confidence. Order taking and
                      processing have become effortless through seamless
                      integration with the Selzor API.
                    </p>
                    <p className="text-sm sm:text-base font-semibold italic text-gray-600">
                      – B2B Seller
                    </p>
                    <div className="flex justify-center text-2xl text-[#1a9588]">
                      <FaQuoteRight />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="basis-full sm:basis-5/12 lg:basis-4/12">
              <div className="flex flex-col gap-2 sm:gap-3">
                <div
                  className="animate-y rounded-2xl sm:rounded-3xl md:rounded-[32px] lg:rounded-[40px] overflow-hidden relative bg-no-repeat bg-top bg-cover"
                  style={{ backgroundImage: `url(${solution_2})` }}
                >
                  <div className="relative h-[120px] xs:h-[136px] sm:h-[200px] md:h-[300px] lg:h-[350px] xl:h-[400px] w-full">
                    <div className="absolute inset-0 z-10 bg-[linear-gradient(#dbf4f1_0%,_transparent_100%)] opacity-60"></div>
                    <div className="absolute inset-0 z-20 p-3 sm:p-4 lg:p-5 xl:p-6">
                      <div className="flex flex-row gap-1 sm:gap-1.5 lg:gap-2 items-center">
                        <div className="flex flex-row items-end">
                          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
                            90
                          </h2>
                          <h3 className="mb-0.5 lg:mb-1 text-lg sm:text-xl">
                            %
                          </h3>
                        </div>
                        <p className="text-sm sm:text-base text-start text-gray-700">
                          Smart Navigation and Streamlined Communication
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col gap-6 sm:gap-8">
            <div className="text-center">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
                Powerful Tools at Your Fingertips
              </h2>
            </div>
            {renderFeatures(features1)}
          </div>
        </div>
        <div className="py-16">
          <p className="py-10 rounded-md bg-[#2bb4a4] text-white border border-[#dbf4f1] text-3xl">
            Gain the insights you need for accurate production and purchase
            forecasting with real-time reports.
          </p>
        </div>
        {renderFeatures(features2)}
        <div className="py-16">
          <p className="py-10 rounded-md bg-[#2bb4a4] text-white border border-[#dbf4f1] text-3xl">
            Streamline your selling process with smarter B2B ordering.
          </p>
        </div>
        {renderFeatures(features3)}
        <div className="py-16">
          <p className="py-10 rounded-md bg-[#2bb4a4] text-white border border-[#dbf4f1] text-3xl">
            Link Selzor to your chosen Inventory, Invoicing, Accounting, and ERP
            systems with ease through our API.
          </p>
        </div>
        {renderFeatures(features4)}
        <div className="pt-10">
          <a
            href="/features"
            className="bg-[#1a9588] rounded-full text-white text-sm hover:bg-[#28b5a6] hover:shadow-xl py-3.5 font-semibold px-6 capitalize"
          >
            View All Features
          </a>
        </div>
        <div className="py-16 pt-10">
          <p className="py-10 rounded-md bg-[#2bb4a4] text-white border border-[#dbf4f1] text-3xl">
            Lead the competition
          </p>
        </div>
      </section>



      {/* <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
            Boost Conversions
          </h2>
          <p className="text-gray-600 text-sm xs:text-base sm:text-lg max-w-3xl mx-auto mb-6 sm:mb-8 lg:mb-10">
            Our features are designed to drive conversions, resulting in higher
            sales and revenue.
          </p>
          <div className="bg-[#dbf4f1] flex flex-col lg:flex-row rounded-2xl sm:rounded-3xl">
            <div className="p-4 sm:p-6 lg:p-8 block sm:block lg:sticky top-20">
              <div className="flex flex-col justify-between">
                <div className="flex flex-wrap justify-center lg:justify-start items-center gap-2 sm:gap-3 lg:gap-4 text-gray-400 text-base sm:text-lg lg:text-xl font-medium mb-4 sm:mb-5 lg:mb-6">
                  {featurestab.map((tab, idx) => (
                    <button
                      key={tab.id}
                      onClick={() => setActive(idx)}
                      className={`transition-colors ${
                        idx !== featurestab.length - 1
                          ? "after:content-['•'] after:mx-2 sm:after:mx-3"
                          : ""
                      } ${
                        active === idx
                          ? "text-gray-600 font-semibold"
                          : "hover:text-gray-800"
                      }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
                <div className="pt-8 sm:pt-12 lg:pt-40 flex flex-col justify-end gap-4 sm:gap-5 lg:gap-6">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-[#b9ece6] text-[#1a9588] rounded-lg sm:rounded-xl flex items-center justify-center shadow-sm">
                    {current.icon}
                  </div>
                  <div className="text-left">
                    <h4 className="text-xl sm:text-2xl text-start">
                      {current.title}
                    </h4>
                    <p className="text-sm sm:text-base text-start text-gray-600">
                      {current.description}
                    </p>
                  </div>
                  <div className="w-full bg-gray-200 h-[4px] sm:h-[6px] rounded-lg">
                    <div
                      className="bg-blue-500 opacity-30 h-full rounded-lg transition-all"
                      style={{ width: current.progress }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2 relative bg-[#EEEDF4] rounded-b-2xl sm:rounded-b-3xl lg:rounded-r-3xl lg:rounded-bl-none h-[300px] sm:h-[400px] lg:h-[500px]">
              <img
                src={current.image}
                alt={current.label}
                className="absolute inset-0 w-full h-full object-cover rounded-b-2xl sm:rounded-b-3xl lg:rounded-r-3xl lg:rounded-bl-none"
              />
            </div>
          </div>
        </div>
      </section> */}
      <FloatingButton />
      <Footer />
    </div>
  );
};

export default OrderManagementSoftware;
